import {
	SimpleCrud,
	SimpleCrudProps,
} from "src/components/SimpleCrud";
import { useBusiness } from "src/hooks/redux/useBusiness";
import {
	actualizarSectorEmpresa,
	agregarSectorEmpresa,
	quitarSectorEmpresa,
} from "src/redux/actions/businessActions";
import { useDispatch } from "src/redux/store";

export const BusinessSectorTab = () => {
	const dispatch = useDispatch();
	const { selectedBusiness, loading } = useBusiness();

	const handleSubmit: SimpleCrudProps["onCreateOrUpdate"] =
		(value, action, selected) =>
			dispatch(
				action === "New"
					? agregarSectorEmpresa(value)
					: actualizarSectorEmpresa(selected.Nombre, value)
			);

	const handleDelete: SimpleCrudProps["onDelete"] = (
		value
	) => dispatch(quitarSectorEmpresa(value.Nombre));

	// Transform the array to match CrudValue type
	const sectoresArray = selectedBusiness?.Sectores 
		? [...new Set(selectedBusiness.Sectores)].map((sector, index) => ({
			Nombre: typeof sector === 'string' ? sector : sector.Nombre || '',
			Activado: true,
			index
		}))
		: [];

	return (
		<SimpleCrud
			key={"Sector"}
			array={sectoresArray}
			isLoading={loading}
			name="Sector"
			onCreateOrUpdate={handleSubmit}
			onDelete={handleDelete}
		/>
	);
};
